<template>
  <div class="OutboxList">
    <!-- 待出箱列表 -->
    &nbsp; &nbsp; &nbsp;
    <div class="top">
      <span>出空箱:</span>
      <van-button
        size="mini"
        type="info"
        v-for="(item, index) in buttonList"
        :key="index"
        @click="exitVoid(index)"
        >{{ item }}</van-button
      >
      <!-- 数组循环 -->
      <van-button type="primary" size="mini" @click="Release()"
        >车放货</van-button
      >
      <van-button type="primary" size="mini" @click="venting()"
        >放空</van-button
      >
    </div>
    &nbsp; &nbsp; &nbsp;
    <div class="search_container" style="display: flex">
      <input
        type="text"
        style="width: 30%"
        placeholder="请输入单号"
        v-model="number"
      />
      &nbsp; &nbsp; &nbsp;
      <input
        type="text"
        style="width: 30%"
        placeholder="客户姓名"
        v-model="detail"
      />
      &nbsp; &nbsp; &nbsp;
      <van-button size="small" type="info" @click="dressing()">
        筛选
      </van-button>
    </div>
    &nbsp; &nbsp; &nbsp;
    <div class="content" style="height: 85vw; overflow: scroll">
      <table class="pure-table pure-table-bordered" style="width: 100%">
        <thead>
          <th>箱号</th>
          <th>货物详情</th>
          <th>容量</th>
          <th>操作</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in packList.data" :key="index">
            <td>{{ item.number }}</td>

            <td>{{ item.detail }}</td>
            <td>{{ item.rong }}<span v-if="item.rong">%</span></td> 
            <td>
              <van-button size="mini" type="info" @click="lookOver(item)"
                >查看</van-button
              >
              <span> &nbsp;</span>
              <van-button size="mini" type="info" @click="flyOut(item)"
                >出箱</van-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <van-pagination
      v-model="current_page"
      :page-count="last_page"
      mode="simple"
      @change="pagingClick()"
    />

    <div style="display: flex; flex-wrap: wrap">
      <van-button
        v-for="(item, index) in mxList"
        :key="index"
        type="default"
        size="small"
        @click="dleClick(index)"
      >
        {{ item }}
        &nbsp; &nbsp; &nbsp;
        <van-icon name="cross" />
      </van-button>
    </div>

    <van-popup v-model="show" position="bottom">
      <table class="pure-table pure-table-bordered" style="width: 100%">
        <thead>
          <th>产品名称</th>
          <th>规格</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in lookOverData" :key="index">
            <td>{{ item.name }}</td>
            <td>{{ item.size }}</td>
          </tr>
        </tbody>
      </table>
    </van-popup>

    <div class="filling-goods-bottom">
      <van-button type="warning" class="bottom-button" @click="go_index()"
        >回首页</van-button
      >
      <van-button type="primary" class="bottom-button" @click="allOut()"
        >全部出箱</van-button
      >
      <van-button type="info" class="bottom-button" @click="RCSout()"
        >RCS出库</van-button
      >
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
export default {
  name: "OutboxList",
  data() {
    return {
      ray: "扫描中",
      buttonList: ["出1", "出2", "出3", "出4"],
      packList: [],
      current_page: 1,
      last_page: 1,
      per_page: 0,
      number: "",
      detail: "",
      show: false,
      lookOverData: [],
      count: 0,
      mxList: [],
    };
  },
  created() {
    this.getOriginalListData();
  },
  methods: {
    RCSout(){
      this.$router.push({
        path:"/RscOutInfo"
      })
    },
    async venting() {
      let packdata = await this.get(this.APIOBJ.carEmpty);
      Toast(packdata.data.msg);
    },
    async dressing() {
      // 筛选
      let packData = await this.get(this.APIOBJ.packList, {
        number: this.number,
        detail: this.detail,
      });
      this.packList = packData.data.data;
      this.current_page = this.packList.current_page;
      this.last_page = this.packList.last_page;
    },
    async getOriginalListData() {
      let packData = await this.get(this.APIOBJ.packList);
      this.packList = packData.data.data;
      this.current_page = this.packList.current_page;
      this.last_page = this.packList.last_page;
    },
    async pagingClick() {
      let packData = await this.get(this.APIOBJ.packList, {
        number: this.number,
        detail: this.detail,
        page: this.current_page,
      });
      this.packList = packData.data.data;
    },
    exitVoid(count) {
      Dialog.confirm({
        title: "",
        message: "",
      })
        .then(async () => {
          // 发送请求
          // Toast.allowMultiple();
          // 开启多个Toast

          // let index = count+1;
          let pack_num = count + 1;
          let result = await this.get(this.APIOBJ.chuKong, { pack_num });
          if (result.status === 200) {
            Toast("指令成功");
          }
          // let successCount = 0;
          // let errorCount = 0;
          // for (let i = 1; i <= count + 1; i++) {
          //   let result = await this.get(this.APIOBJ.chuKong);
          //   if (result.data.data.success == true) {
          //     successCount++;
          //   } else {
          //     errorCount++;
          //   }
          // }
          // if (errorCount === 0) {
          //   // 表示没有失败
          //   setTimeout(() => {
          //     Toast("指令成功");
          //   }, 3000);
          // } else {
          //   // 表示有失败的
          //   setTimeout(() => {
          //     Toast(`${successCount}成功${errorCount}失败`);
          //   }, 3000);
          // }
        })
        .catch(() => {});
    },
    async lookOver(item) {
      // 查看
      let data = await this.get(this.APIOBJ.packMx, { goods: item.number });
      this.lookOverData = data.data.data;
      this.show = true;
    },
    async allOut(){
     let pack_num = this.mxList.join(',')
     let packing =  await this.get(this.APIOBJ.chuXiang , {pack_num})
     console.log(packing)
     if(packing.data.status === 1){
      Toast(packing.data.msg)
      this.mxList = []
     }
    },
    dleClick(index){
      Dialog({
        message: `确定要删除${this.mxList[index]}单号吗`,
      }).then(() => {
        this.mxList.splice(index , 1);
      });
    },
    async flyOut(item) {

      if(this.mxList.indexOf(item.number) === -1){
        this.mxList.push(item.number)
      }else{
        Toast(`${item.number}请勿重复加入待出箱列表`)
      }

      // let pack_num = item.number;
      // let data = await this.get(this.APIOBJ.chuXiang, { pack_num });
      // Toast(data.data.msg);
    },
    go_index() {
      // 会首页
      Dialog.confirm({
        message: "确认回到首页吗?",
      }).then(() => {
        this.$router.push("/home");
      });
    },
    async Release() {
      if (this.count === 0) {
        let packing = await this.get(this.APIOBJ.carRelease);
        if (packing.status === 200) {
          Toast(packing.data.msg);
        }
        setTimeout(() => {
          this.count = 0;
        }, 2000);
      } else {
        Dialog.confirm({
          message: "您确定连续放货吗，注意安全",
        }).then(async () => {
          let packing = await this.get(this.APIOBJ.carRelease);
          if (packing.status === 200) {
            Toast(packing.data.msg);
          }
        });
      }
      this.count++;
    },
  },
};
</script>

<style>
.filling-goods-bottom {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -10px;
}
.top {
  display: flex;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0 auto;
}

td,
th {
  padding: 0;
}
.pure-table {
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
  border: 1px solid #cbcbcb;
}

.pure-table caption {
  color: #000;
  font: italic 85%/1 arial, sans-serif;
  padding: 1em 0;
  text-align: center;
}

.pure-table td,
.pure-table th {
  border-left: 1px solid #cbcbcb;
  border-width: 0 0 0 1px;
  font-size: inherit;
  margin: 0;
  overflow: visible;
  /* padding: 0.5em 1em; */
}

.pure-table thead {
  background-color: #e0e0e0;
  color: #000;
  /* text-align: left; */
  vertical-align: bottom;
}

.pure-table td {
  background-color: transparent;
}

.pure-table-bordered td {
  border-bottom: 1px solid #cbcbcb;
}

.pure-table-bordered tbody > tr:last-child > td {
  border-bottom-width: 0;
}
</style>